import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton `QueryClient` for the app. 5-min default `staleTime`, no refetch on
 * window focus (chat polling and live updates handle freshness explicitly).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
